import { render, staticRenderFns } from "./browse-asset-modal.vue?vue&type=template&id=6104d0ce&scoped=true&"
import script from "./browse-asset-modal.vue?vue&type=script&lang=ts&"
export * from "./browse-asset-modal.vue?vue&type=script&lang=ts&"
import style0 from "./browse-asset-modal.vue?vue&type=style&index=0&id=6104d0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6104d0ce",
  null
  
)

export default component.exports